// extracted by mini-css-extract-plugin
export default {"select":"zWufP"};